import DividerWithSpace from './DividerWithSpace';

export default DividerWithSpace;
